import LeftsideMenu from './components/leftside-menu';
import TopsideMenu from './components/topside-menu';
import RightsideMenu from './components/rightside-menu';
import BottomsideMenu from './components/bottomside-menu';
import Gradient from './components/gradient';
import './App.scss';

import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/home';
import About from './pages/about';
import Portfolio from './pages/portfolio';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <Gradient />
          <LeftsideMenu />
          <TopsideMenu />
          <RightsideMenu />
          <BottomsideMenu />
        {/* Основной контент страниц */}
        </header>
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;